"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fill: "#8BD7F8",
  fillRule: "evenodd",
  d: "M4 12a8 8 0 1 1 16 0 8 8 0 1 1-16 0m2.878-.047a5.033 5.033 0 1 0 10.065 0 5.033 5.033 0 0 0-10.065 0m3.518 3.118V8.938l4.794 3.067z",
  clipRule: "evenodd"
}), 'Youku');
